var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReleasesManagement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_18997_192",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 48,
    height: 48
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_18997_192)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 24C17.8 24 15.9167 23.2167 14.35 21.65C12.7833 20.0833 12 18.2 12 16C12 13.8 12.7833 11.9167 14.35 10.35C15.9167 8.78333 17.8 8 20 8C22.2 8 24.0833 8.78333 25.65 10.35C27.2167 11.9167 28 13.8 28 16C28 18.2 27.2167 20.0833 25.65 21.65C24.0833 23.2167 22.2 24 20 24ZM4 40V34.4C4 33.3 4.28333 32.2667 4.85 31.3C5.41667 30.3333 6.2 29.6 7.2 29.1C8.9 28.2333 10.8167 27.5 12.95 26.9C15.0833 26.3 17.4333 26 20 26H20.7C20.9 26 21.1 26.0333 21.3 26.1C21.0333 26.7 20.8083 27.325 20.625 27.975C20.4417 28.625 20.3 29.3 20.2 30H20C17.6333 30 15.5083 30.3 13.625 30.9C11.7417 31.5 10.2 32.1 9 32.7C8.7 32.8667 8.45833 33.1 8.275 33.4C8.09167 33.7 8 34.0333 8 34.4V36H20.6C20.8 36.7 21.0667 37.3917 21.4 38.075C21.7333 38.7583 22.1 39.4 22.5 40H4ZM32 42L31.4 39C31 38.8333 30.625 38.6583 30.275 38.475C29.925 38.2917 29.5667 38.0667 29.2 37.8L26.3 38.7L24.3 35.3L26.6 33.3C26.5333 32.8333 26.5 32.4 26.5 32C26.5 31.6 26.5333 31.1667 26.6 30.7L24.3 28.7L26.3 25.3L29.2 26.2C29.5667 25.9333 29.925 25.7083 30.275 25.525C30.625 25.3417 31 25.1667 31.4 25L32 22H36L36.6 25C37 25.1667 37.375 25.35 37.725 25.55C38.075 25.75 38.4333 26 38.8 26.3L41.7 25.3L43.7 28.8L41.4 30.8C41.4667 31.2 41.5 31.6167 41.5 32.05C41.5 32.4833 41.4667 32.9 41.4 33.3L43.7 35.3L41.7 38.7L38.8 37.8C38.4333 38.0667 38.075 38.2917 37.725 38.475C37.375 38.6583 37 38.8333 36.6 39L36 42H32ZM34 36C35.1 36 36.0417 35.6083 36.825 34.825C37.6083 34.0417 38 33.1 38 32C38 30.9 37.6083 29.9583 36.825 29.175C36.0417 28.3917 35.1 28 34 28C32.9 28 31.9583 28.3917 31.175 29.175C30.3917 29.9583 30 30.9 30 32C30 33.1 30.3917 34.0417 31.175 34.825C31.9583 35.6083 32.9 36 34 36ZM20 20C21.1 20 22.0417 19.6083 22.825 18.825C23.6083 18.0417 24 17.1 24 16C24 14.9 23.6083 13.9583 22.825 13.175C22.0417 12.3917 21.1 12 20 12C18.9 12 17.9583 12.3917 17.175 13.175C16.3917 13.9583 16 14.9 16 16C16 17.1 16.3917 18.0417 17.175 18.825C17.9583 19.6083 18.9 20 20 20Z",
    fill: "#00E378"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReleasesManagement);
export default __webpack_public_path__ + "static/media/releases-management.27b72d7a984776129d51079935ed0562.svg";
export { ForwardRef as ReactComponent };